<template>
  <div class="question__item" v-if="detail">
    <!-- 问 -->
    <div class="ask_wrap clearfix">
      <div class="img_wrap left">
        <div class="ask">问</div>
      </div>
      <div class="title_wrap left">
        <p class="title">{{ detail.userName }}：<span class="yf-text_12">{{ detail.createdAt }}</span></p>
        <p class="title-1">
          <nuxt-link :to="`/question/detail/${detail.id}`" class="text">{{ detail.body }}<span v-if="detail.gcoins > 0"><i class="iconfont icon-jinbi"></i><em> {{ detail.gcoins }}G币</em></span></nuxt-link>
        </p>
      </div>
    </div>
    <!-- 答 -->
    <div class="answer_wrap" v-if="isMy">
      <div class="clearfix">
        <div class="img_wrap left">
          <nuxt-link target="_blank" rel="noopener" :to="`/question/list/${detail.answerId}`">
            <img class="ask teacherimg" v-lazy="isSupportWebp(detail.answerUserAvatar)" :alt="detail.answerUserName" />
          </nuxt-link>
        </div>
        <div class="title_wrap left">
          <p class="title">
            <nuxt-link target="_blank" rel="noopener" :to="`/question/list/${detail.answerId}`">{{ detail.answerUserName }}</nuxt-link><span class="yf-text_12" v-if="detail.answer">：{{ detail.answerTime }}</span>
          </p>
          <!--已经回答(用户和老师)-->
          <p class="text title-1" v-if="detail.answer">{{ detail.answer }}</p>
        </div>
      </div>
      <template v-if="detail.status === 2">
        <!-- 已退款/已过期 -->
        <div class="name_wrap">
          <span :class="detail.gcoins > 0 ? 'pay' : 'free'" class="weihuida">{{ detail.gcoins > 0 ? '超时未回答，G币已退回' : '超时未回答，提问已过期' }}</span>
        </div>
      </template>
      <template v-else-if="detail.status === 0">
        <!-- 未回答（提问者） -->
        <div class="name_wrap" v-if="detail.userId === authUser.id">
          <span class="weihuida">等待回答</span>
        </div>
        <!-- 未回答（老师） -->
        <div class="text" v-else-if="detail.teacherId === authUser.id">
          <p @click="isShowAnswerBox = !isShowAnswerBox" class="teacher_action">{{ isShowAnswerBox ? '关闭输入框' : '立即回答该问题' }}</p>
          <!--回答框块-->
          <div v-show="isShowAnswerBox" class="area_wrap">
            <textarea placeholder="请输入回答答案" maxlength="150" v-model.trim="answerBoxContent"></textarea>
            <p class="btn_wrap yf-text_12">
              <span>限150字</span>
              <button type="button" @click="handleAnswer">发送</button>
            </p>
          </div>
        </div>
      </template>
    </div>
    <div class="answer_wrap clearfix" v-else>
      <div class="img_wrap left">
        <nuxt-link target="_blank" rel="noopener" :to="`/question/list/${detail.answerId}`">
          <img class="ask teacherimg" v-lazy="isSupportWebp(detail.answerUserAvatar)" :alt="detail.answerUserName" />
        </nuxt-link>
      </div>
      <div class="title_wrap left">
        <p class="title">
          <nuxt-link target="_blank" rel="noopener" :to="`/question/list/${detail.answerId}`">{{ detail.answerUserName }} </nuxt-link>：<span class="yf-text_12">{{ detail.answerTime }}</span>
        </p>
        <!--有权限查看-->
        <div class="text answer" v-if="detail.answer">{{ detail.answer }}</div>
        <!--无权限查看-->
        <div class="text" v-else-if="detail.status === 0">
          <span class="weihuida">等待回答</span>
        </div>
        <div class="text" v-else-if="detail.status === 1">
          <span class="teacher_action" @click.prevent="handleUnlock(detail)">已回答，点击查看详细内容</span>
        </div>
        <div class="text" v-else-if="detail.status === 2">
          <span class="weihuida">该问答已过期</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from '@/utils/Dialog'
import Webp from '@/mixins/Webp'

export default {
  mixins: [Webp],
  name: 'component-question-item',
  props: {
    data: Object,
    // user/question和question/list页面下我的问答会返回true
    isMy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      detail: this.data,
      // 老师我的问答
      isShowAnswerBox: false,
      answerBoxContent: null
    }
  },
  methods: {
    // 老师回答操作
    handleAnswer (e) {
      if (!this.$isLogin() || !this.answerBoxContent) {
        return
      }
      let params = {
        id: this.detail.id,
        content: this.answerBoxContent
      }
      Dialog.confirm('回答问题', '是否将此回答发送给用户？').then(() => {
        e.target.disabled = false
        this.$axios._post('Ask/Answer', params).then(res => {
          e.target.disabled = true
          this.$notify({
            title: '成功',
            message: '回答成功',
            type: 'success'
          })
          this.$axios._get('Ask/Detail', { id: this.detail.id }).then(res => {
            this.detail = res
          }).catch(() => {
            Dialog.alert('出现错误，请重新刷新页面！')
          })
        }).then(() => {
          this.$store.commit('user/setFcoins', this.detail.gcoins)
        }).catch(err => {
          e.target.disabled = true
        })
      })
    },
    // 用户解锁答案
    handleUnlock (item) {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      // 老师身份不能解锁别人问题
      if (this.isTeacher) {
        Dialog.alert('您是尊贵的老师身份，目前暂时还不支持老师解锁问题哦~~')
        return
      }

      Dialog.unlockAsk(item, res => {
        this.$axios._get('Ask/Detail', { id: item.id }).then(res => {
          this.$notify({
            type: 'success',
            title: '成功',
            message: '解锁成功'
          })
          this.$store.commit('user/setGcoins', this.authUser.gcoins - item.gcoins)
          this.detail = res
        })
      })
    }
  },
  computed: {
    authUser () {
      return this.$store.state.user.data
    },
    isTeacher () {
      return this.$store.getters['user/isTeacher']
    }
  }
}
</script>

<style lang="less">
.question__item {
  padding: 20px 0; border-bottom: 1px solid #f2f2f2;
  .ask_wrap,
  .answer_wrap {
    .img_wrap {
      width: 37px;
      div.ask { background: #e53b3c; }
      .ask {
        width: 27px; height: 27px; color: #FFF; text-align: center; line-height: 25px; font-size: 16px; border-radius: 50%; margin-right: 10px;
      }
    }
    .title_wrap {
      width: 683px;
      .title {
        line-height: 24px; height: 24px; font-size: 16px; color: #666;
        a {
          font-size: 14px;
          &:hover { color: #C00; }
        }
      }
      .title-1 {
        line-height: 24px; overflow: hidden; display:inline-block; font-size: 16px; color: #666; padding: 2px 0; padding-bottom: 0; word-break: break-all;
      }
    }
  }
  .ask_wrap {
    .title_wrap {
      .text {
        &:hover { color: #C00; }
        span {
          border: 1px solid #ffcd64; padding: 0px 10px; border-radius: 15px; margin-left: 6px;
          i { color: #ffcd64; font-size: 18px; }
          em { color: #e43a3b; font-size: 16px; margin-left: 2px; }
        }
      }
    }
  }
  .answer_wrap {
    .name_wrap { height: 30px; line-height: 30px;
      span { font-size: 14px;}
      .name { color: #e43a3d; }
      .time { color: #999; }
      .pay { background: #A9BBFD; }
      .free { color: #A2A0A1; }
    }
    > .text { font-size: 16px; word-break: break-all; color: #666; line-height: 24px; margin-left: 37px;
      span { color: #5f98ef; font-size: 14px; }
    }
    .answer {
      font-size: 16px; margin-top: 5px; color: #444;
    }
    .area_wrap { width: 682px; border: 1px solid #dddee2; padding: 10px;
      textarea { width: 100%; border: none; resize: none; height: 80px; font-size: 14px; outline: none; }
      .btn_wrap { height: 30px; text-align: right;
        span { color: #cbcbcb; }
        button {
          background: #6098ef; cursor: pointer; color: #FFF; width:78px ; height: 30px; border: none; border-radius: 5px; margin: 0 5px;
        }
      }
    }
  }
}
.weihuida {
  display: inline-block; margin-left: 38px; line-height: 24px; text-align: center; border-radius: 12px; background: #CCC;color: #FFF; padding: 0 20px; cursor: default;
}
.teacher_action { font-size: 14px; color: #5f98ef; cursor: pointer; display: inline-block; }
</style>
